import { render } from "./VendorManagement.vue?vue&type=template&id=1afd070f&scoped=true"
import script from "./VendorManagement.vue?vue&type=script&lang=js"
export * from "./VendorManagement.vue?vue&type=script&lang=js"

import "./VendorManagement.vue?vue&type=style&index=0&id=1afd070f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afd070f"]])

export default __exports__